import {createStore} from "vuex";
import {token, TokenState} from "@/store/token";
import {sideBar, SideBarState} from "@/store/sideBar";
import {navigation, NavigationState} from "@/store/navigation";
import {commonModal, CommonModalState} from "@/store/commonModal";
import {modals, ModalsState} from "@/store/modals";

export interface RooteState{
  token: TokenState;
  sideBar: SideBarState;
  navigation: NavigationState,
  modal: CommonModalState,
  modals: ModalsState
}

export default createStore({
  modules: {token, sideBar, navigation, modal: commonModal, modals},
});
